import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const roleGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const allowedRoles = route.data?.['roles'] as string[];
  const userRole = authService.getUserType();

  if (!allowedRoles || allowedRoles.includes(userRole!)) {
    return true;
  }

  // 🚫 Access denied
  router.navigate(['/access-denied']); // or /access-denied
  return false;
};
